import { StreamingTrackRow } from 'fym-shared/src/music24/streaming';

export type TrackSortKey = 'name' | 'streams' | 'listeners' | 'saves' | 'earnings' | 'change';

/**
 * The net of the largest currency of a track. It sorts only: two currencies are never added, so
 * a track with two currencies sorts by its larger amount.
 */
function earningsOf(track: StreamingTrackRow): number | null {
  const amounts = (track.earnings ?? []).map((money) => money.net).filter((net): net is number => net !== null);
  return amounts.length === 0 ? null : Math.max(...amounts);
}

function valueOf(track: StreamingTrackRow, key: Exclude<TrackSortKey, 'name'>): number | null {
  switch (key) {
    case 'streams':
      return track.streams;
    case 'listeners':
      return track.listeners;
    case 'saves':
      return track.saves;
    case 'earnings':
      return earningsOf(track);
    case 'change':
    default:
      return track.changePct;
  }
}

/** The tracks in the order of a column (design d1). A missing number goes last in both directions. */
export function sortTracks(tracks: StreamingTrackRow[], key: TrackSortKey, descending: boolean): StreamingTrackRow[] {
  const direction = descending ? -1 : 1;
  return [...tracks].sort((left, right) => {
    if (key === 'name') {
      return direction * left.name.localeCompare(right.name);
    }
    const a = valueOf(left, key);
    const b = valueOf(right, key);
    if (a === null && b === null) {
      return 0;
    }
    if (a === null) {
      return 1;
    }
    if (b === null) {
      return -1;
    }
    return direction * (a - b);
  });
}
